import { Injectable } from "@angular/core";
import { DecisionActionRequest } from "../../models/home";
import { DecisionActionLike } from "./home-decision-action.types";
import { DecisionActionValueReader } from "./home-decision-action-request.builder.input-values";
import {
  DecisionActionTransportKind,
  DecisionActionTransportPayloadBuilder
} from "./home-decision-action-request.builder.transport-payload";

@Injectable({ providedIn: "root" })
export class HomeDecisionActionRequestBuilder {
  private readonly valueReader = new DecisionActionValueReader();
  private readonly transportBuilder = new DecisionActionTransportPayloadBuilder(
    this.valueReader
  );

  buildRequest(
    action: DecisionActionLike | null,
    formValue?: Record<string, unknown> | null
  ): DecisionActionRequest | null {
    return this.transportBuilder.buildRequest(action, formValue);
  }

  resolveTransportKind(
    actionKey: string,
    endpointTemplate?: string
  ): DecisionActionTransportKind {
    return this.transportBuilder.resolveTransportKind(actionKey, endpointTemplate);
  }

  buildTransportPayload(
    action: DecisionActionLike,
    request: DecisionActionRequest,
    values: Record<string, unknown>,
    extraValues: Record<string, unknown>
  ): Record<string, unknown> | undefined {
    return this.transportBuilder.buildTransportPayload(
      action,
      request,
      values,
      extraValues
    );
  }

  resolvePostponeDays(
    values: Record<string, unknown>,
    request: DecisionActionRequest,
    template: Record<string, unknown>
  ): number {
    return this.transportBuilder.resolvePostponeDays(values, request, template);
  }

  toPostponeDays(value: string): number | undefined {
    return this.transportBuilder.toPostponeDays(value);
  }

  compactActionRequest(request: DecisionActionRequest): DecisionActionRequest {
    return this.transportBuilder.compactActionRequest(request);
  }

  readStringValue(
    values: Record<string, unknown>,
    keys: readonly string[]
  ): string | undefined {
    return this.valueReader.readStringValue(values, keys);
  }

  readUnknownValue(
    values: Record<string, unknown>,
    keys: readonly string[]
  ): unknown {
    return this.valueReader.readUnknownValue(values, keys);
  }

  readNumberValue(
    values: Record<string, unknown>,
    keys: readonly string[]
  ): number | undefined {
    return this.valueReader.readNumberValue(values, keys);
  }

  readBooleanValue(
    values: Record<string, unknown>,
    keys: readonly string[]
  ): boolean | undefined {
    return this.valueReader.readBooleanValue(values, keys);
  }

  toPayloadRecord(value: unknown): Record<string, unknown> {
    return this.valueReader.toPayloadRecord(value);
  }

  compactPayload(
    payload: Record<string, unknown>
  ): Record<string, unknown> | undefined {
    return this.valueReader.compactPayload(payload);
  }
}
